import script from "./MiniBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./MiniBanner.vue?vue&type=script&setup=true&lang=ts"

import "./MiniBanner.vue?vue&type=style&index=0&id=61e518c3&lang=scss"

const __exports__ = script;

export default __exports__